import { Box, Button, FormControlLabel, IconButton, Radio, RadioGroup, Typography } from "@mui/material";
import {
	logicProfileWarehouseAssoc,
	storeMastShortNameKey,
	storeMastStoreCodeKey,
	warehouseMappingLogicColumns,
	whMappingTypeCol,
	whMapPriorityTypesColumns,
	zonesList,
} from "../../data";
import { useEffect, useState } from "react";
import { getColDefaultValue } from "components/EboStoreV4/data";
import { inputTypes, isNewKey } from "data/globalData";
import { ReplenishmentState } from "context/ReplenishmentContext.js";
import { selectOptKeyName } from "components/ReplenishmentDashboard/data";
import { Add, DeleteRounded } from "@mui/icons-material";
import CustomInputField from "components/ReplenishmentDashboard/ReusableComponents/CustomInputField/CustomInputField";

const WarehouseMappingSection = ({
	profileData,
	setProfileData,
	disableEdit = false,
	handleDelete = (row) => {},
	wearHouses = [],
}) => {
	const { allStores } = ReplenishmentState();
	const disabled = !wearHouses?.length;
	const p1p2Columns = wearHouses?.reduce((acc, row, i) => {
		i += 1;
		acc[`p${i}`] = { ...warehouseMappingLogicColumns.priority_list, name: `Priority ${i}`, key: `p${i}` };
		return acc;
	}, {});
	const disableP1P2ListDropdownFun = (column, data, option) => {
		let arr = [];
		profileData?.[logicProfileWarehouseAssoc]?.forEach((row) => {
			if (row?.id === data?.id) {
				arr = [...arr, ...data?.[warehouseMappingLogicColumns.proiority_for.key]];
			} else {
				arr = [...arr, ...row?.[warehouseMappingLogicColumns.proiority_for.key]];
			}
		});
		Object?.keys(p1p2Columns)?.forEach((pcol) => arr.push(data?.[pcol]));

		console.log(arr, "zmnbfmnsdbxm", data, p1p2Columns);
		if (column?.input_type === inputTypes.MULTIPLE_SELECT.key)
			return [...new Set(arr)]?.includes(option.key) && !data[column?.key].includes(option.key);
		else return [...new Set(arr)]?.includes(option.key) && !(data[column?.key] === option.key);
	};
	const defWhMappingFields = {
		[isNewKey]: true,
		[warehouseMappingLogicColumns.proiority_for.key]: getColDefaultValue(warehouseMappingLogicColumns.proiority_for),
		...wearHouses?.reduce((acc, row, i) => {
			acc[`p${++i}`] = getColDefaultValue(warehouseMappingLogicColumns.priority_list);
			return acc;
		}, {}),
	};
	const updatedWarehouseColumns = (ColDataObj, whProirityType) => {
		let list = [];
		let regex = new RegExp(/^p\d+$/);

		if (whProirityType === whMapPriorityTypesColumns.wh_map_store.key)
			list = allStores?.map((row) => ({
				name: row?.[storeMastShortNameKey],
				key: row?.[storeMastStoreCodeKey],
			}));
		else if (whProirityType === whMapPriorityTypesColumns.wh_map_state.key)
			list = allStores
				?.reduce((acc, row) => {
					if (!acc?.includes(row?.["State"])) acc?.push(row?.["State"]);
					return acc;
				}, [])
				?.map((state) => ({
					name: state,
					key: state,
				}));
		else if (whProirityType === whMapPriorityTypesColumns.wh_map_zone.key)
			list = allStores
				?.reduce((acc, row) => {
					if (!acc?.includes(row?.["REGION"])) acc?.push(row?.["REGION"]);
					return acc;
				}, [])
				?.map((region) => ({
					name: region,
					key: region,
				}));
		return Object.keys(ColDataObj)
			?.map((row) => ColDataObj[row])
			?.reduce((acc, row) => {
				if (row?.key === warehouseMappingLogicColumns.proiority_for.key)
					acc[row?.key] = {
						...row,
						[selectOptKeyName]: {
							...row[selectOptKeyName],
							list,
						},
					};
				else if (regex.test(row?.key))
					acc[row.key] = {
						...row,
						[selectOptKeyName]: {
							...row[selectOptKeyName],
							list: wearHouses,
							getOptionLabel: (row) => ({ name: row, key: row }),
						},
					};
				else acc[row?.key] = row;
				return acc;
			}, {});
	};

	const [warehouseMappingColumns, setWarehouseMappingColumns] = useState(
		updatedWarehouseColumns(
			{
				[warehouseMappingLogicColumns.proiority_for.key]: warehouseMappingLogicColumns.proiority_for,
				...p1p2Columns,
			},
			profileData?.[whMappingTypeCol.key] ?? whMapPriorityTypesColumns.wh_map_zone.key
		)
	);
	useEffect(() => {
		setWarehouseMappingColumns(
			updatedWarehouseColumns(
				{
					[warehouseMappingLogicColumns.proiority_for.key]: warehouseMappingLogicColumns.proiority_for,
					...p1p2Columns,
				},
				profileData?.[whMappingTypeCol.key] ?? whMapPriorityTypesColumns.wh_map_zone.key
			)
		);
	}, [wearHouses]);
	const [disabledDropdowns, setDisabledDropdowns] = useState([]);

	const handleAddWarehouseRowClick = () => {
		setProfileData((prev) => {
			return {
				...prev,
				[logicProfileWarehouseAssoc]: [
					...prev?.[logicProfileWarehouseAssoc],
					{ ...defWhMappingFields, [isNewKey]: true, id: new Date().valueOf() },
				],
			};
		});
	};
	const handleWarehouseMappingDataChange = (currentRow) => {
		return (data) => {
			setProfileData((prev) => {
				return {
					...prev,
					[logicProfileWarehouseAssoc]: prev?.[logicProfileWarehouseAssoc]?.map((row) => {
						if (row.id === currentRow?.id) {
							return { ...row, ...data };
						}
						return row;
					}),
				};
			});
			setDisabledDropdowns((prev) => {
				let arr = [];
				profileData?.[logicProfileWarehouseAssoc]?.forEach((row) => {
					if (row?.id === data?.id) {
						arr = [...arr, ...data?.[warehouseMappingLogicColumns.proiority_for.key]];
						Object?.keys(p1p2Columns)?.forEach((pcol) => arr.push(data?.[pcol]));
					} else {
						arr = [...arr, ...row?.[warehouseMappingLogicColumns.proiority_for.key]];
						Object?.keys(p1p2Columns)?.forEach((pcol) => arr.push(row?.[pcol]));
					}
				});

				console.log(arr, "zmnbfmnsdbxm", data, p1p2Columns);
				return [...new Set(arr)];
			});
		};
	};

	const handleWhMapRadioChange = (e) => {
		setProfileData((prev) => {
			return { ...prev, [whMappingTypeCol.key]: e.target.value, [logicProfileWarehouseAssoc]: [] };
		});
		setWarehouseMappingColumns((prev) => updatedWarehouseColumns(prev, e.target.value));
	};

	return (
		<Box width="100%">
			<Box display="flex" alignItems="center" columnGap="10px">
				<RadioGroup
					aria-labelledby="demo-controlled-radio-buttons-group"
					name="controlled-radio-buttons-group"
					row
					value={profileData?.[whMappingTypeCol.key]}
					onChange={handleWhMapRadioChange}>
					{Object.keys(whMapPriorityTypesColumns)
						?.map((row) => whMapPriorityTypesColumns[row])
						?.map((row) => {
							return <FormControlLabel disabled={disableEdit} value={row.key} control={<Radio />} label={row.name} />;
						})}
				</RadioGroup>
				<Box display={disableEdit ? "none" : "block"}>
					<Button
						variant="contained"
						size="small"
						startIcon={<Add />}
						onClick={handleAddWarehouseRowClick}
						disabled={disabled}>
						Add Warehouse
					</Button>
				</Box>
			</Box>

			{profileData?.[logicProfileWarehouseAssoc]?.map((rowData) => {
				return (
					<Box width="100%" display="flex">
						<Box display="flex" columnGap={"1.5%"} rowGap="10px" flexWrap="wrap" width="100%">
							{Object.keys(warehouseMappingColumns)
								?.map((row) => warehouseMappingColumns[row])
								?.map((row) => {
									if (disableEdit) row = { ...row, input_type: inputTypes.AUTO_GENERATE.key };
									return (
										<CustomInputField
											column={row}
											data={rowData}
											setData={handleWarehouseMappingDataChange(rowData)}
											width={row?.key === warehouseMappingColumns?.proiority_for?.key ? "20%" : "15%"}
											selectOptObjName={selectOptKeyName}
											disabledDropdowns={disabledDropdowns} // disable dropdown if the option is already selected in the other dropdowns
											disableEdit={disableEdit}
											disabledOptionFun={disableP1P2ListDropdownFun}
										/>
									);
								})}
							<Box alignSelf="flex-end" display={disableEdit ? "none" : "block"}>
								<IconButton onClick={() => handleDelete(rowData)}>
									<DeleteRounded />
								</IconButton>
							</Box>
						</Box>
					</Box>
				);
			})}
		</Box>
	);
};

export default WarehouseMappingSection;
